import { getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

export const getTranslatedImage = (imageName: string) => {
  const locale = getLocale();

  return require(`../images/translatedImages/${locale}/${imageName}`);
};
